import { Component, ElementRef, HostBinding, Injector, Input, OnInit } from '@angular/core';
import { ApiOauthService, ApiWpService, MareAuthService } from '@mare-common/ngx-mare-auth';
import { ApiService } from '@mare-common/ngx-selfcaring-web-components';
import { RoutingService } from './services/routing.service';
import { CompanyInterface, CompanyServiceAbstract, UserInterface, UserServiceAbstract } from '@mare-common/ngx-mare-user';
import { environment } from 'src/environments/environment';
import { CommonConfig } from './shared/common-config/common-config';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { PurchaseService } from './services/purchase.service';

declare var window: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {


  @Input() wpnonce!: string;

  genericAttribute: any;
  private userService!: UserServiceAbstract;
  private companyService!: CompanyServiceAbstract;
  logoPath: any;
  dashboardLayout!: any


  // wpnonce: string = 'b77e94c602';
  // basicauth: string = 'ZnJhbmNlc2NvLnNlc3NhOmR0Q0J2Zzk4MU14REQwVW5saUJ4QkVMNw==';
  // // basicauth: string = 'Y2xhdWRpb2F1dHVvcmk6SjBBaUVHQlpJa3haUVVRWVdxbG9vckN4';
  // // basicauth: string = 'Y2xhdWRpb2F1dHVvcmk6aTJiSkJMQzBQMDIxQ3o2eFpBS3FjczBB';
  // serviceEndpoint: string = 'https://servicecompany.maredigital.it/wp-json';
  constructor(
    private apiSerivce: ApiOauthService,
    private apiWpService: ApiWpService,
    selfcaringApiService: ApiService,
    routingService: RoutingService,
    private mareAuthService: MareAuthService,
    // private userService: UserServiceAbstract,
    // private companyService: CompanyServiceAbstract,
    private elementRef: ElementRef,
    private injector: Injector,
    private _commonConfig: CommonConfig,
    private purchaseService: PurchaseService
    // private translate: TranslateService
  ) {
    // const toConfigure = environment.isWp && environment.wpConfig != undefined && environment.wpConfig != null;
    // const se = environment.isWp  && environment.wpConfig != undefined && environment.wpConfig != null ? environment.wpConfig?.serviceEndpoint : '';
    // const wpnonce = environment.isWp  && environment.wpConfig != undefined && environment.wpConfig != null ? environment.wpConfig?.wpnonce : '';
    // const basicAuth = environment.isWp  && environment.wpConfig != undefined && environment.wpConfig != null ? environment.wpConfig?.basicAuth : '';

    // this.translate.getTranslation('it').subscribe((res: any) => {
    //   console.log(res);
    // });
    this.wpnonce = this.elementRef.nativeElement.getAttribute('wpnonce');
    // this.logoPath = this.elementRef.nativeElement.getAttribute('logoPath');
    this.genericAttribute = this.elementRef.nativeElement;
    /* impostiamo le variabili di ambiente a livello globale in mareauth*/
    if(environment.isWp && !environment.isInWp){
      apiWpService.configured = false;
      if(!environment.wpNoConfig)
        apiWpService.setEnvironment(environment.wpConfig?.serviceEndpoint, environment.wpConfig?.wpnonce, environment.wpConfig?.basicAuth);
    }

    if (this.wpnonce && environment.wpConfig) {
      environment.wpConfig.wpnonce = this.wpnonce;
    }
    if (environment.dashboardLayout) {
      if(window.dashboardLayout){
        this._commonConfig.setDashboardLayout(window.dashboardLayout);
        // this.dashboardLayout = window.dashboardLayout;
      } else {
        this._commonConfig.setDashboardLayout(environment.dashboardLayout);
        // this.dashboardLayout = environment.dashboardLayout;
      }
    }
    // this.commonConfig.setDashboardLayout();
    // if(toConfigure){
    //   apiWpService.configured = false;
    //   apiWpService.setEnvironment(se, wpnonce, basicAuth);
    // }
    if (environment.isWp && !environment.isInWp && !environment.wpNoConfig) {
      apiSerivce.configured = false;
      apiSerivce.setEnvironment(environment.wpConfig?.serviceEndpoint, environment.wpConfig?.wpnonce, environment.wpConfig?.basicAuth);
    }

    if (this.mareAuthService.isWp) {
      if (this.wpnonce)
        this.apiWpService.setWpnonce(this.wpnonce);
      setTimeout(() => {
        /* Recupero la prima volta il token per innescare il silent refresh... */
        this.mareAuthService.retrieveToken().then((token) => {
          // console.debug('setupToken', token);
        })
      }, 3000);
      
    }
    this.userService = this.injector.get(UserServiceAbstract);
    this.companyService = this.injector.get(CompanyServiceAbstract);

    // if(toConfigure){
    //   apiSerivce.configured = false;
    //   apiSerivce.setEnvironment(se, wpnonce, basicAuth);
    // }
    // selfcaringApiService.setEnvironment('https://servicecompany.maredigital.it/selfcaringservice/selfcaring', this.wpnonce, this.basicauth);
    if (environment.isWp && !environment.isInWp && !environment.wpNoConfig) {
      selfcaringApiService.setEnvironment('/selfcaringservice/selfcaring', environment.wpConfig?.wpnonce, environment.wpConfig?.basicAuth);
    }
    routingService.setup();
    this.setLogoPath();
  }

  ngOnInit() {
    // if(this.mareAuthService.isWp) {
    //   if(this.wpnonce)
    //     this.apiWpService.setWpnonce(this.wpnonce);
    // }
    this.userService.getUser().then((user: UserInterface | null) => {
      console.log('user',user)
      this.companyService.getCompany().then((company: CompanyInterface | null) => {
        console.log('company',company)
      });
    });
  }

  // getNativeAttribute(name: string) {
  //   return this.genericAttribute.getAttribute(name);
  // }

  setLogoPath() {
    const logopath = this.elementRef.nativeElement.getAttribute('logopath');
    if (logopath && logopath.trim() != '') {
      this._commonConfig.setSiteLogo(logopath);
    }
  }
}